import { useContext } from "react";
import { CreationInfo } from "../../../../generated/data-contracts";
import { CreationListMode } from "../../../../models";
import { AvisModal } from "../../../shared/components/modal";
import { AvisContext } from "../../../shared/context";
import { CreationsPage } from "../creationsList/CreationsPage";

interface ICreationPickerProps {
  defaultCreationTypeId: number | undefined;
  selectedCreation: CreationInfo | undefined;
  setSelectedCreation: React.Dispatch<
    React.SetStateAction<CreationInfo | undefined>
  >;
  onClose: () => void;
  onConfirm: () => void;
}
export function CreationPicker(props: Readonly<ICreationPickerProps>) {
  const {
    selectedCreation,
    defaultCreationTypeId,
    setSelectedCreation,
    onConfirm,
    onClose,
  } = props;
  const { res } = useContext(AvisContext);

  return (
    <AvisModal
      className="modal-form-with-scroll"
      isOpen={true}
      onConfirm={onConfirm}
      onClose={onClose}
      title={res("authors_UnidentifiedCreations_action_SearchExisting")}
      confirmButtonText={res("button_Choose")}
      confirmButtonDisabled={!selectedCreation}
    >
      <CreationsPage
        defaultCreationTypeId={defaultCreationTypeId}
        creationListMode={CreationListMode.UnidentifiedPicker}
        selectedCreation={selectedCreation}
        setSelectedCreation={setSelectedCreation}
      />
    </AvisModal>
  );
}
